export enum HttpCode {
  Ok = 0,
  BadRequest = -1,
  Unauthorized = 200001,
  Forbidden = 70004,
}
